import { render } from "./forgot.vue?vue&type=template&id=b7743e14&scoped=true&ts=true"
import script from "./forgot.vue?vue&type=script&lang=ts"
export * from "./forgot.vue?vue&type=script&lang=ts"

import "./forgot.vue?vue&type=style&index=0&id=b7743e14&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7743e14"]])

export default __exports__